import React, { useState } from 'react';
import classNames from 'classnames';
import BaseModal from '../../../BaseModal';
import styles from './styles.module.scss';

const CalculationErrorModal = ({ isOpen, text, errorMessage, onClose, onTryAgain }) => {
  const [loading, setLoading] = useState(false);

  const onPressConfirm = () => {
    const result = onTryAgain();
    if (result instanceof Promise) {
      setLoading(true);
      result.finally(() => {
        setLoading(false);
      });
    }
  };
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <p className={styles.title}>{text}</p>
        </div>
        <div className={styles.modalBody}>
          <p className={styles.errorMessage}>{!loading && errorMessage}</p>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.cancelButton} onClick={onClose}>Close</button>
          <button
            className={classNames(styles.confirmButton, { [styles.confirmButtonLoading]: loading })}
            onClick={onPressConfirm}
          >Try again</button>
        </div>
      </div>
    </BaseModal>
  );
};

export default CalculationErrorModal;
